export default __webpack_public_path__ + "static/media/fortune-10.a1198551.png";